// extracted by mini-css-extract-plugin
export default {"projectInfoSliderWrapper":"projectInfoSlider_projectInfoSliderWrapper__Sm3SY"};